// extracted by css-extract-rspack-plugin
export default {"wrapper":"searchbar-module__wrapper___IN6hq","icon":"searchbar-module__icon___SEB8p","field":"searchbar-module__field___dPdc7"};